import React from 'react'

const WebdesignStrategies = () => {


  return (
    <div className="max-w-7xl mx-auto px-4 mt-20">
  {/* En-tête de section optimisé */}
  <div className="text-center lg:text-left mb-16">
    <h2 className='text-2xl md:text-3xl font-medium text-slate-500 tracking-wide uppercase'>
      Bereit für maximales Business-Wachstum?
    </h2>
    <h1 className='text-3xl md:text-4xl lg:text-5xl font-bold text-primary mt-4 tracking-tight'>
      Die digitale <span className='text-secondary relative inline-block'>
        LÖSUNG
        <span className="absolute bottom-0 left-0 w-full h-1 bg-secondary/20 -z-10 rounded-full"></span>
      </span> ist hier...
    </h1>

    <p className="mt-8 text-lg text-slate-600 leading-relaxed">
      „Als Ihre spezialisierte <strong>Webdesign Agentur</strong> unterstützen wir Sie dabei, Ihre <strong>digitale Zukunft</strong> zu gestalten. Wir kombinieren modernste <strong>Webentwicklung</strong> mit strategischer <strong>SEO Optimierung</strong>, um Ihre Marke an die Spitze der Google-Ergebnisse zu bringen. Als erfahrener <strong>WordPress Experte</strong> und Spezialist für ganzheitliche <strong>E-Commerce Lösungen</strong> schaffen wir digitale Plattformen, die überzeugen. Ob Sie einen performanten <strong>Shopify Shop</strong> erstellen lassen möchten oder eine maßgeschneiderte Unternehmenswebsite benötigen – wir verwandeln Besucher in loyale Kunden.“
    </p>
  </div>

  
</div>
  )
}

export default WebdesignStrategies;